import { Grid, Icon, Link, Button } from "capitalrx-components-2.0";
import { Shelf } from "capitalrx-components-2.0/lib/layout";
import { contactUsPressed } from "../../utils/contactUsPressed";
import { Logo } from "capitalrx-components-2.0/lib/general";

import DownloadAppLogo from "@/components/DownloadApp/DownloadAppLogo";

import styles from "./Footer.module.scss";

const Footer = (): JSX.Element => {
  return (
    <footer className={styles.FooterWrapper} data-testid="advantage-footer">
      <hr className={styles.SectionDividerLine} aria-hidden="true" />
      <Grid container className={styles.TopFooterWrapper}>
        <Grid item colLg={3} colMd={2} colSm={6}>
          <div className={styles.FooterCapitalRXSectionWithLogo}>
            <Link href="https://www.judi.health/" className={styles.LinkToCorporate} testId="footer-link-capital-rx">
              <span aria-hidden="true">
                <Logo name="caprx-horizontal" testId="capital-rx-logo-footer" className={styles.CapitalrxLogo} />
              </span>
              <span className="companyName">Capital Rx</span>
            </Link>
            <div className={styles.FooterCapitalRXSectionWithLogoAddress} data-testid="advantage-footer-address">
              Capital Rx Headquarters
              <br />
              One World Trade Center
              <br />
              New York, NY 10007
              <br />
            </div>
            <div className={styles.FooterCapitalRXSectionWithLogoColumnContent}>
              <Link href="tel:(888) 617-6521" className={styles.LinkWithoutUnderscore} testId="link-to-customer-support-phone">
                <Icon name="phone-landline" ariaHidden="true" testId="phone-icon" />
                (888) 617-6521
              </Link>
            </div>
            <div className={styles.FooterCapitalRXSectionWithLogoColumnContent}>
              <Link href="mailto:info@cap-rx.com" className={styles.LinkWithoutUnderscore} testId="link-to-capitalrx-email">
                <Icon name="envelope-closed" ariaHidden="true" testId="envelope-icon" />
                info@cap-rx.com
              </Link>
            </div>
          </div>
        </Grid>
        <Grid item colLg={2} colMd={1} colSm={6}>
          <div className={styles.FooterCapitalRXSectionFollowUs}>
            <div className={styles.FooterCapitalRXSectionFollowUsColumnTitle}>Follow Us</div>
            <div className={styles.FooterCapitalRXSectionFollowUsColumnContent}>
              <Link href="https://www.linkedin.com/company/cap-rx/" className={styles.LinkWithoutUnderscore} testId="link-to-linkedin">
                <Icon name="linked-in" ariaHidden="true" testId="linkedin-icon" />
                LinkedIn
              </Link>
            </div>
            <div className={styles.FooterCapitalRXSectionFollowUsColumnContent}>
              <Link href="https://twitter.com/cap_rx" className={styles.LinkWithoutUnderscore} testId="link-to-twitter">
                <Icon name="twitter" ariaHidden="true" testId="twitter-icon" />
                Twitter
              </Link>
            </div>
            <div className={styles.FooterCapitalRXSectionFollowUsColumnContent}>
              <Link
                href="https://www.youtube.com/channel/UCVAnrQMs7hzWmgwUox2vqCA"
                className={styles.LinkWithoutUnderscore}
                testId="link-to-youtube"
              >
                <Icon name="youtube" ariaHidden="true" testId="youtube-icon" />
                YouTube
              </Link>
            </div>
            <div className={styles.FooterCapitalRXSectionFollowUsColumnContent}>
              <Link href="https://www.instagram.com/capital_rx/" className={styles.LinkWithoutUnderscore} testId="link-to-instagram">
                <Icon name="instagram" ariaHidden="true" testId="instagram-icon" />
                Instagram
              </Link>
            </div>
            <div className={styles.FooterCapitalRXSectionFollowUsColumnContent}>
              <Link href="https://www.facebook.com/capitalrx" className={styles.LinkWithoutUnderscore} testId="link-to-facebook">
                <Icon name="facebook" ariaHidden="true" testId="facebook-icon" />
                Facebook
              </Link>
            </div>
          </div>
        </Grid>
        <Grid item colLg={2} colMd={1} colSm={6}>
          <div className={styles.FooterCapitalRXSectionAboutUs}>
            <div className={styles.FooterCapitalRXSectionAboutUsColumnTitle}>About Us</div>
            <div className={styles.FooterCapitalRXSectionAboutUsColumnContent}>
              <Link href="https://www.judi.health/about/our-story" className={styles.LinkWithoutUnderscore} testId="link-to-capitalrx-overview">
                Our Story
              </Link>
            </div>
            <div className={styles.FooterCapitalRXSectionAboutUsColumnContent}>
              <Link
                href="https://www.judi.health/about/leadership"
                className={styles.LinkWithoutUnderscore}
                testId="link-to-capitalrx-leadership"
              >
                Leadership Team
              </Link>
            </div>
            <div className={styles.FooterCapitalRXSectionAboutUsColumnContent}>
              <Link href="https://www.judi.health/about/careers" className={styles.LinkWithoutUnderscore} testId="link-to-capitalrx-jobs">
                We&apos;re Hiring
              </Link>
            </div>
            <div className={styles.FooterCapitalRXSectionAboutUsColumnContent}>
              <Link href="https://www.judi.health/insights" className={styles.LinkWithoutUnderscore} testId="link-to-capitalrx-news">
                In The News
              </Link>
            </div>
          </div>
        </Grid>

        <Grid item colLg={5} colMd={3} colSm={6} className={styles.FooterContactUsSection} testId="footer-contact-us-section">
          <div className={styles.FooterContactUsSectionAdvantageProgram}>Interested in rolling out your own Advantage program?</div>
          <div className={styles.FooterContactUsSectionContactUsText}>Contact us to scale or white label your own card.</div>
          <div className={styles.FooterContactUsSectionContactUsButton}>
            <Button size="small" onClick={contactUsPressed} testId="footer-contact-us-button">
              Contact Us
            </Button>
          </div>
          <div className={styles.FooterContactUsSectionDownloadCRxAdvantageAppText}>Download the CRx Advantage App</div>
          <div className={styles.FooterContactUsSectionDownloadCRxAdvantageAppButtons}>
            <DownloadAppLogo className={styles.IconSize} />
          </div>
        </Grid>
      </Grid>

      <hr className={styles.SectionDividerLine} aria-hidden="true" />

      <div className={styles.CopyrightsSection}>
        <Shelf className={styles.CopyrightsSectionInfo} data-testid="capitalrx-copyright">
          &copy; 2025 Capital Rx, Inc.
          <Shelf.Spacer />
          <Link href="/privacy-policy" className={styles.LinkWithoutUnderscore} testId="link-to-privacy-policy">
            Privacy Policy
          </Link>
          <Link href="/terms-and-conditions" className={styles.LinkWithoutUnderscore} testId="link-to-terms">
            Terms and Conditions
          </Link>
        </Shelf>
      </div>
    </footer>
  );
};

export default Footer;
